"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _eventEmitter = _interopRequireDefault(require("./eventEmitter.c"));

var _react = _interopRequireDefault(require("react"));

var _dataModel = _interopRequireDefault(require("../../../common/backbone/dataModel"));

var _escapeRegExp2 = _interopRequireDefault(require("../../../utils/escapeRegExp"));

var _formatter2 = _interopRequireDefault(require("../../../utils/formatter"));

var _sync = _interopRequireDefault(require("../../../common/backbone/sync/sync"));

var _dataCollection = _interopRequireDefault(require("../../../common/backbone/dataCollection"));

var _l10n2 = _interopRequireDefault(require("../../../common/l10n"));

var _bindModel = require("../../DataBind/bindModel");

var _constants = require("../constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default =
/*#__PURE__*/
function (_EventEmitter) {
  (0, _inherits2["default"])(_default, _EventEmitter);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, _default);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(_default)).call.apply(_getPrototypeOf2, [this].concat(_args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "uiStates", _constants.UI_STATES);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fetchBeforeRender", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "bindModel", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _bindModel.bindModel.apply(void 0, [(0, _assertThisInitialized2["default"])(_this)].concat(args));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "unbindModel", function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _bindModel.unbindModel.apply(void 0, [(0, _assertThisInitialized2["default"])(_this)].concat(args));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_createElementRef", function (name) {
      _this.__refFunctionsCache = _this.__refFunctionsCache || {};

      if (!_this.__refFunctionsCache[name]) {
        _this.__refFunctionsCache[name] = function (el) {
          _this.crefs = _this.crefs || {};
          _this.crefs[name] = el;
        };
      }

      return _this.__refFunctionsCache[name];
    });
    return _this;
  }

  (0, _createClass2["default"])(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // загрузим коллекцию и/или модель вьюхи
      this.loadStorages();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // flag for unmounted components
      this.isUnmounted = true;
      this.stopListening();
      this.off();
    }
    /**
     * lifecycle method. Run after all storages (fetchBeforeRender) are loaded and state become INTERACTIVE
     */

    /* componentReady() {
    }*/

    /**
     * lifecycle method. Run after all storages (fetchBeforeRender) are loaded and state still STANDBY
     * @param {function} resolve
     * @return {Promise.resolve}
     */

    /* componentWillReady(resolve) {
        return resolve();
    }*/

    /**
     * override
     * ensure that setState called on mounted component
     * @param {object} state
     * @param {function} [cb]
     * @param {object} [options]
     * @return {Promise}
     */

  }, {
    key: "setState",
    value: function setState(state, cb, options) {
      var _this2 = this;

      if (!this.isUnmounted) {
        if (!(options === null || options === void 0 ? void 0 : options.silent)) {
          (0, _bindModel.transmitToModel)(this, state);
        }

        if (typeof cb === 'function') {
          return (0, _get2["default"])((0, _getPrototypeOf3["default"])(_default.prototype), "setState", this).call(this, state, cb);
        } else {
          return new Promise(function (resolve) {
            return (0, _get2["default"])((0, _getPrototypeOf3["default"])(_default.prototype), "setState", _this2).call(_this2, state, resolve);
          });
        }
      } else {
        return Promise.resolve();
      }
    }
  }, {
    key: "isUiInitial",
    value: function isUiInitial() {
      var _this$state;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.ui;
      return state === this.uiStates.INITIAL;
    }
  }, {
    key: "isUiInteractive",
    value: function isUiInteractive() {
      var _this$state2;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_this$state2 = this.state) === null || _this$state2 === void 0 ? void 0 : _this$state2.ui;
      return state === this.uiStates.INTERACTIVE;
    }
  }, {
    key: "isUiStandBy",
    value: function isUiStandBy() {
      var _this$state3;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_this$state3 = this.state) === null || _this$state3 === void 0 ? void 0 : _this$state3.ui;
      return state === this.uiStates.STANDBY;
    }
  }, {
    key: "isUiProcessing",
    value: function isUiProcessing() {
      var _this$state4;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_this$state4 = this.state) === null || _this$state4 === void 0 ? void 0 : _this$state4.ui;
      return state === this.uiStates.PROCESSING;
    }
  }, {
    key: "isUiError",
    value: function isUiError() {
      var _this$state5;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_this$state5 = this.state) === null || _this$state5 === void 0 ? void 0 : _this$state5.ui;
      return state === this.uiStates.ERROR;
    }
  }, {
    key: "isUiHidden",
    value: function isUiHidden() {
      var _this$state6;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_this$state6 = this.state) === null || _this$state6 === void 0 ? void 0 : _this$state6.ui;
      return state === this.uiStates.HIDDEN;
    }
  }, {
    key: "isUiPassed",
    value: function isUiPassed() {
      var _this$state7;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_this$state7 = this.state) === null || _this$state7 === void 0 ? void 0 : _this$state7.ui;
      return state === this.uiStates.PASSED;
    }
  }, {
    key: "isUiRedirect",
    value: function isUiRedirect() {
      var _this$state8;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_this$state8 = this.state) === null || _this$state8 === void 0 ? void 0 : _this$state8.ui;
      return state === this.uiStates.REDIRECT;
    }
  }, {
    key: "uiInteractive",
    value: function uiInteractive() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.setState(_objectSpread({
        error: null
      }, data, {
        ui: this.uiStates.INTERACTIVE
      }));
    }
  }, {
    key: "uiStandBy",
    value: function uiStandBy() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.setState(_objectSpread({
        error: null
      }, data, {
        ui: this.uiStates.STANDBY
      }));
    }
  }, {
    key: "uiProcessing",
    value: function uiProcessing() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.setState(_objectSpread({
        error: null
      }, data, {
        ui: this.uiStates.PROCESSING
      }));
    }
  }, {
    key: "uiError",
    value: function uiError() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.setState(_objectSpread({}, data, {
        ui: this.uiStates.ERROR
      }));
    }
  }, {
    key: "uiHidden",
    value: function uiHidden() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.setState(_objectSpread({
        error: null
      }, data, {
        ui: this.uiStates.HIDDEN
      }));
    }
  }, {
    key: "uiPassed",
    value: function uiPassed() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.setState(_objectSpread({
        error: null
      }, data, {
        ui: this.uiStates.PASSED
      }));
    }
  }, {
    key: "uiRedirect",
    value: function uiRedirect() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.setState(_objectSpread({
        error: null
      }, data, {
        ui: this.uiStates.REDIRECT
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state9;

      var result = null,
          template;
      var ui = (_this$state9 = this.state) === null || _this$state9 === void 0 ? void 0 : _this$state9.ui;

      if (this.template) {
        template = this.template;
      } else if (ui && this.templates) {
        template = this.templates[ui];
      }

      if (template) {
        if (typeof template === 'function') {
          result = template.call(this);
        } else {
          result = template;
        }
      } else {
        result = _react["default"].createElement("div", null);

        if (process && process.env.NODE_ENV !== 'production') {
          var _this$state10;

          if ((_this$state10 = this.state) === null || _this$state10 === void 0 ? void 0 : _this$state10.ui) {
            window.console.error("Render: missed template for ".concat(this.state.ui, " in component ").concat(this.constructor.displayName, ". Check you state.ui or template(s) property."));
          } else {
            window.console.error("Render: missed template in component ".concat(this.constructor.displayName, ". Check you state.ui or template(s) property."));
          }
        }
      }

      return result;
    }
    /**
     * load all storages from fetchBeforeRender
     * non - blocking!
     * @param {object} options
     * @return {object}
     */

  }, {
    key: "loadStorages",
    value: function () {
      var _loadStorages = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var _this3 = this;

        var options,
            deferData,
            queryOptions,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                deferData = [], queryOptions = _objectSpread({
                  reset: true,
                  silent: true,
                  parse: true,
                  validate: false
                }, options);

                if (!(this.fetchBeforeRender && this.fetchBeforeRender instanceof Array && this.fetchBeforeRender.length)) {
                  _context.next = 9;
                  break;
                }

                this.fetchBeforeRender.forEach(function (storage) {
                  var storageInstance = _this3.state && _this3.state[storage] || _this3.props[storage] || _this3[storage] || storage;

                  if (storageInstance instanceof _dataModel["default"] || storageInstance instanceof _dataCollection["default"]) {
                    deferData.push(storageInstance);
                  } else if (typeof storageInstance === 'function') {
                    deferData.push({
                      fetch: function fetch(options) {
                        var Transport = _sync["default"].getEngine('xhr');

                        if (Transport) {
                          return new Transport(options).get().then(function (data) {
                            return storageInstance(data);
                          });
                        } else {
                          return Promise.resolve();
                        }
                      }
                    });
                  }
                });

                if (!deferData.length) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return this.uiStandBy();

              case 7:
                _context.next = 9;
                return Promise.all(deferData.map(function (item) {
                  // load storages is non blocking procedure, resolve and reject are equal
                  return new Promise(function (resolve) {
                    item.fetch(queryOptions).then(function (response) {
                      return resolve(response);
                    }, function (error) {
                      return resolve(error);
                    });
                  });
                }));

              case 9:
                _context.next = 11;
                return this._handleComponentReady();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadStorages() {
        return _loadStorages.apply(this, arguments);
      }

      return loadStorages;
    }()
  }, {
    key: "_handleComponentReady",
    value: function () {
      var _handleComponentReady2 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(typeof this.componentWillReady === 'function')) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.componentWillReady();

              case 4:
                _context2.next = 6;
                return this.uiInteractive();

              case 6:
                if (!(typeof this.componentReady === 'function')) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 9;
                return this.componentReady();

              case 9:
                this.__component_is_ready = true;
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                if (process && process.env.NODE_ENV !== 'production') {
                  window.console.error("".concat(_context2.t0, " in component ").concat(this.constructor.displayName));
                }

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 12]]);
      }));

      function _handleComponentReady() {
        return _handleComponentReady2.apply(this, arguments);
      }

      return _handleComponentReady;
    }()
    /**
     * get data
     * from current refs
     * from extraData method
     * @return {*}
     */

  }, {
    key: "getFormData",
    value: function getFormData() {
      var data = {},
          extraData,
          ref;

      var refs = _objectSpread({}, this.crefs || {}),
          keys = Object.keys(refs);

      keys.forEach(function (name) {
        ref = refs[name];

        if (ref && !(ref instanceof HTMLElement) && typeof ref.getFormData === 'function') {
          var refData = ref.getFormData();

          if ((0, _typeof2["default"])(refData) === 'object') {
            data = _objectSpread({}, data, {}, refData);
          }
        }
      });

      if (typeof this.getFormExtraData === 'function') {
        extraData = this.getFormExtraData(data);
      }

      return _objectSpread({}, data, {}, extraData);
    }
    /**
     * Usual props list for bind component to DataModel storage.
     * Supported all components from P24C collection
     * @param {string} attribute
     * @param {object} props
     * @return {*}
     */

  }, {
    key: "bindProps",
    value: function bindProps(attribute) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var result = {};

      if (attribute) {
        this._removeErrorOnModelChange(attribute);

        result = _objectSpread({
          elementRef: this._createElementRef(attribute),
          storage: this.getModel(),
          attribute: attribute,
          name: name,
          bind: true,
          error: !!this._matchError({
            name: attribute
          })
        }, props);
      }

      return result;
    }
  }, {
    key: "_removeErrorOnModelChange",
    value: function _removeErrorOnModelChange(attribute) {
      var _this4 = this;

      var storage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getModel();
      this._removeErrorListeners = this._removeErrorListeners || {};

      if (!this._removeErrorListeners[attribute] && storage instanceof _dataModel["default"] && attribute) {
        this.listenTo(storage, "change:".concat(attribute), function () {
          if (_this4._matchError({
            name: attribute
          })) {
            _this4.removeError({
              name: attribute
            });
          }
        });
        this._removeErrorListeners[attribute] = true;
      }
    }
  }, {
    key: "ctrlProps",

    /**
     * Usual property set for controlled components.
     * @param {string} [name]
     * @param {object} props
     * @return {object}
     */
    value: function ctrlProps(name) {
      var _this5 = this;

      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.crefs = this.crefs || {};
      var ref,
          error = false,
          attribute = null,
          value = null,
          checked = null;

      if (name) {
        ref = this._createElementRef(name);
        attribute = name;
        error = !!this._matchError({
          name: name
        }); // exception for Radio component

        if (props.radio) {
          value = props.value;
          checked = this.state ? this.state[name] === props.value : false;
        } else {
          value = this.state ? this.state[name] : null;
          checked = typeof value === 'boolean' ? value : null;
        }

        this.__controlled_state_callbacks = this.__controlled_state_callbacks || {};

        if (!this.__controlled_state_callbacks[name]) {
          this.__controlled_state_callbacks[name] = function (event) {
            var target = event && event.target;
            var value;

            if (target) {
              if (target.type === 'checkbox') {
                value = target.checked;
              } else {
                value = target.value;
              }
            } else {
              value = event;
            }

            return _this5.setState((0, _defineProperty2["default"])({}, name, value)).then(function () {
              if (_this5._matchError({
                name: attribute
              })) {
                return _this5.removeError({
                  name: attribute
                });
              } else {
                return Promise.resolve();
              }
            });
          };
        }
      }

      return _objectSpread({
        elementRef: ref,
        bind: false,
        error: error,
        attribute: attribute,
        name: name,
        value: value,
        checked: checked,
        onChange: this.__controlled_state_callbacks && this.__controlled_state_callbacks[name]
      }, props);
    }
  }, {
    key: "_matchError",
    value: function _matchError() {
      var _this$state11;

      var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (_this$state11 = this.state) === null || _this$state11 === void 0 ? void 0 : _this$state11.error;
      var result = null;

      if (list && list.length) {
        result = list.find(function (subject) {
          return pattern.name === subject.name;
        });
      }

      return result;
    }
    /**
     * обработчик ошибок
     * отрисовка ошибки
     * @param {object|Array} errorList
     * @return {Promise}
     */

  }, {
    key: "errorHandler",
    value: function errorHandler(errorList) {
      var _this$state12,
          _this6 = this;

      if (!errorList) {
        return Promise.resolve();
      }

      errorList = errorList instanceof Array ? errorList : [errorList];
      var newList = [],
          currentList = ((_this$state12 = this.state) === null || _this$state12 === void 0 ? void 0 : _this$state12.error) || []; // заменяем дубликаты новыми копиями

      currentList.forEach(function (error) {
        newList.push(_this6._matchError(error, errorList) || error);
      }); // дополняем список новыми ошибками

      errorList.forEach(function (error) {
        if (!_this6._matchError(error, newList)) {
          newList.push(error);
        }
      });
      return this.uiError({
        error: newList
      });
    }
    /**
     * opts: error filter
     * opts.name - remove only {name} errors;
     * @param {object} [errorList]
     * @return {Promise}
     */

  }, {
    key: "removeError",
    value: function removeError(errorList) {
      var _this7 = this;

      if (errorList) {
        errorList = errorList instanceof Array ? errorList : [errorList];
      } else {
        errorList = [];
      }

      return new Promise(function (resolve) {
        if (_this7.isUiError() && _this7.state.error && _this7.state.error instanceof Array) {
          var nextList = []; // remove only selected error

          if (errorList.length) {
            nextList = [];

            _this7.state.error.forEach(function (error) {
              if (!_this7._matchError(error, errorList)) {
                nextList.push(error);
              }
            });
          }

          if (nextList.length) {
            _this7.setState({
              error: nextList
            }).then(function () {
              return resolve();
            });
          } else {
            return _this7.uiInteractive({
              error: null
            }).then(function () {
              return resolve();
            });
          }
        } else {
          resolve();
        }
      });
    }
    /**
     * getting error list, matched with passed arguments
     * if name is supplied - return only error with matched name;
     * in other cases return error without name attribute
     * @param {String} [name]
     * @return {Array}
     */

  }, {
    key: "getError",
    value: function getError(name) {
      var _this$state$error,
          _this8 = this;

      var result = [];

      if (this.isUiError() && ((_this$state$error = this.state.error) === null || _this$state$error === void 0 ? void 0 : _this$state$error.length)) {
        this.state.error.forEach(function (error) {
          // named errors
          if (name && error.name === name) {
            result.push(error); // unnamed errors
          } else if (!name && !error.name) {
            result.push(error);
          }
        });
      }

      if (result.length) {
        result = result.map(function (error) {
          return _objectSpread({}, error, {
            message: _this8.l10n(error.message || 'error', error.options)
          });
        });
      }

      return result;
    }
    /**
     * Выдает переведенную строку непосредственно для вставки в шаблон
     * @param {String} key
     * @param {Object} [options]
     * @return {String}
     */

  }, {
    key: "l10n",
    value: function l10n(key, options) {
      return _l10n2["default"].translate(key, options);
    }
    /**
     * get model of step
     * @return {*}
     */

  }, {
    key: "getModel",
    value: function getModel() {
      return this.state && this.state.model || this.props.model || this.model || null;
    }
    /**
     * view validation. Recursive validation of each sub view.
     * @param {object} data
     * @return {*}
     */

  }, {
    key: "validate",
    value: function validate(data) {
      var _this9 = this;

      var error = [],
          ref,
          currentValidationPassed = true;

      var refs = _objectSpread({}, this.crefs || {}),
          keys = Object.keys(refs),
          model = this.getModel(),
          subValidationPassed = [];

      keys.forEach(function (name) {
        ref = refs[name];

        if (ref && !(ref instanceof HTMLElement) && typeof ref.validate === 'function') {
          subValidationPassed.push(ref.validate());
        }
      }); // validation of current component

      data = data || this.getFormData();

      if (model) {
        var validationData = _objectSpread({}, model.attributes, {}, data),
            attrs = Object.keys(validationData);

        error = attrs.map(function (name) {
          return model.validate((0, _defineProperty2["default"])({}, name, validationData[name]), {
            validateValueOnly: true
          });
        });

        if (typeof model.extraValidate === 'function') {
          error = error.concat(model.extraValidate(validationData));
        }
      } // extra validation


      if (typeof this.extraValidate === 'function') {
        error = error.concat(this.extraValidate(data));
      } // remove "passed" validation values like undefined, false


      error = error.filter(function (e) {
        return !!e;
      });
      this.removeError().then(function () {
        if (error.length) {
          _this9.errorHandler(error);
        }
      });

      if (error.length) {
        currentValidationPassed = false;
      }

      return currentValidationPassed && subValidationPassed.every(function (result) {
        return result === true;
      });
    }
    /**
     * override method
     * @param {object} data
     * @return {boolean}
     */

  }, {
    key: "extraValidate",
    value: function extraValidate(data) {
      return false;
    }
    /**
     * https://facebook.github.io/react/tips/dangerously-set-inner-html.html
     *  React dangerouslySetInnerHTML synax
     *  @param {string} html
     *  @return {object}
     */

  }, {
    key: "rawHTML",
    value: function rawHTML() {
      var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      window.console.warn('.rawHTML() is deprecated and will be removed. Use native __html instead');
      return {
        __html: html
      };
    }
  }, {
    key: "formatter",
    value: function formatter() {
      return _formatter2["default"].apply(void 0, arguments);
    }
  }, {
    key: "escapeRegExp",
    value: function escapeRegExp() {
      return _escapeRegExp2["default"].apply(void 0, arguments);
    }
  }]);
  return _default;
}(_eventEmitter["default"]);

exports["default"] = _default;
(0, _defineProperty2["default"])(_default, "displayName", 'Base.Views.Main');